// extracted by mini-css-extract-plugin
export default {"map":"AddressMap_map__+6AYw","searchBox":"AddressMap_searchBox__I2Dnj"};